import { MultipleInverter } from "./MultipleInverter";

export class CombinationBuffer {
    map: { [panelCount: number]: MultipleInverter[] } = {};
    panelCountMin: number = 999999;
    panelCountMax: number = 0;
}
